//import * as XLSX from 'xlsx';
import XLSX from "sheetjs-style";
import Papa from "papaparse";

// Clase base abstracta para adaptadores de datos
// Proporciona una interfaz común para analizar diferentes formatos de archivo
class Adapter {
  // Método abstracto que debe ser implementado por las subclases
  // Lanza un error si no se sobrescribe
  parse(data) {
    throw new Error("Método parse debe ser implementado por la subclase");
  }
}

// Implementación del adaptador para archivos Excel (xls/xlsx) usando la biblioteca SheetJS
class SheetJSAdapter extends Adapter {
  // Parsea archivos Excel mediante:
  // 1. Lectura del archivo como ArrayBuffer
  // 2. Uso de la biblioteca XLSX para parsear el libro de trabajo
  // 3. Conversión de la primera hoja a JSON
  // 4. Extracción de encabezados desde la primera fila o metadata de la hoja
  parse({ file, delimiterOverride }) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(ws, { defval: "" });

        // Determina los encabezados desde los datos JSON o metadata de la hoja
        const headers = json.length
          ? Object.keys(json[0])
          : XLSX.utils.sheet_to_json(ws, { header: 1 })[0] || [];

        // Resuelve con la estructura de datos parseada
        resolve({ rows: json, headers, delimiter: "\t" });
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }
}

// Implementación del adaptador para archivos de texto plano (csv/txt) usando PapaParse
class PlainTextAdapter extends Adapter {
  // Parsea archivos de texto mediante:
  // 1. Lectura del archivo como texto
  // 2. Uso de PapaParse para parsear CSV
  // 3. Manejo de encabezados, líneas vacías y conversión de tipos
  parse({ file, delimiterOverride }) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => {
        const blob = e.target.result;
        Papa.parse(blob, {
          header: true,
          skipEmptyLines: true,
          dynamicTyping: true,
          delimiter: delimiterOverride || "",
          complete: results =>
            resolve({
              rows: results.data,
              headers: results.meta.fields,
              delimiter: results.meta.delimiter || delimiterOverride || ","
            }),
          error: reject
        });
      };
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }
}

// Implementación del patrón de fábrica para crear adaptadores adecuados
// Mapea extensiones de archivo a sus adaptadores correspondientes
export const FactoryAdapter = {
  xls: new SheetJSAdapter(), // Para formato Excel antiguo (xls)
  xlsx: new SheetJSAdapter(), // Para formato Excel nuevo (xlsx)
  csv: new PlainTextAdapter(), // Para archivos de valores separados por comas (csv)
  txt: new PlainTextAdapter() // Para archivos de texto plano (txt)
};
